<template>
  <svg
    aria-hidden="true"
    width="46.08"
    height="46.08"
    viewBox="0.48 0.48 23.04 23.04"
    fill="currentColor"
    style="font-size: 2.88em"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class AttachmentIcon extends Vue {}
</script>
